import { Product } from '@commerce/types/product'
import { getConfigByLocale } from '@lib/locale'
import { useLocalStorage } from 'usehooks-ts'

export type RecentlyViewedProduct = {
  id: string
  name: string
  handle: string
  locale: string
  path: string
  popular: boolean
  images: Array<{
    url: string
    alt?: string
    altText?: string
  }>
  metafields: Array<{
    key: string
    value: string
  }>
  price: {
    value: number
    currencyCode?: string
  }
  productType?: string
  colourCode?: string | null
  viewedAt: Date
}

const MAX_RECENTLY_VIEWED = 12
const STORAGE_KEY = 'bwk_rvp'

export const useRecentlyViewedProducts = (locale: string) => {
  const recentlyViewedProductsKey = getConfigByLocale(locale, 'recentlyViewedProductsKey')
  const [allRecentlyViewed, setAllRecentlyViewed] = useLocalStorage<RecentlyViewedProduct[]>(
    STORAGE_KEY,
    []
  )
  const recentlyViewed = allRecentlyViewed.filter(product => product.locale === recentlyViewedProductsKey)
  const addProduct = (product: Product) => {
    if (!product?.id || !product?.handle) return
    const productInfo: RecentlyViewedProduct = {
      id: product.id,
      name: product.name,
      handle: product.handle,
      locale: recentlyViewedProductsKey,
      path: product.path || '/',
      popular: product.popular || false,
      images: product.images || [],
      price: product.price,
      productType: product.productType,
      colourCode: product.colourCode,
      viewedAt: new Date(),
      metafields: product.metafields || [],
    }
    setAllRecentlyViewed((prev) => {
      const filtered = prev.filter((p) => !(p.id === product.id && p.locale === recentlyViewedProductsKey))
      const updated = [productInfo, ...filtered]
      return updated.slice(0, MAX_RECENTLY_VIEWED)
    })
  }


  return {
    recentlyViewed,
    addProduct,
  }
} 